import React from 'react';
export function Footer() {
  return <footer className="px-4 py-6 bg-gray-100 text-center text-gray-500" data-id="element-226">
      <div className="uppercase text-xs opacity-75 mb-3" data-id="element-227">
        DIES IST EINE WERBEANZEIGE UND KEIN ECHTER NACHRICHTENARTIKEL, BLOG ODER
        VERBRAUCHERSCHUTZ-UPDATE
      </div>
      <div className="mb-2 text-sm" data-id="element-228">
        <p data-id="element-229">MARKETING-HINWEIS: Diese Website wird von NUERA betrieben.</p>
      </div>
      <div className="mb-4 text-sm" data-id="element-230">
        <p data-id="element-231">
          AFFILIATE-HINWEIS: Dieses Advertorial kann Affiliate-Links enthalten.
        </p>
      </div>
      <div className="mb-3 text-sm" data-id="element-232">
        <p data-id="element-233">© 2025 Alle Rechte vorbehalten.</p>
      </div>
      <div className="flex justify-center space-x-4 text-sm" data-id="element-234">
        <a href="https://mynuera.de/policies/legal-notice" className="hover:underline" data-id="element-235">
          Impressum
        </a>
        <a href="https://mynuera.de/policies/privacy-policy" className="hover:underline" data-id="element-236">
          Datenschutz
        </a>
        <a href="https://mynuera.de/policies/refund-policy" className="hover:underline" data-id="element-237">
          Widerrufsrecht
        </a>
        <a href="https://mynuera.de/policies/terms-of-service" className="hover:underline" data-id="element-238">
          AGB
        </a>
      </div>
    </footer>;
}